/**
 * Created by Carsten Bühler
 * User: c.buehler on 18.04.2019
 * Copyright: xdot GmbH 2019
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AmdRequireComponent } from 'plugin/liferay-widgets-react-web';
import {
    DetailsListItem,
    DetailsListItemMeasurementBox,
    DetailsListItemNameBox,
    DetailsListItemStatusBox,
    DetailsListItemTitle
} from './DetailsListItemComponents';

const FliwasObjectListItem = ({ item, selectedNamedList, onLoad, onClickDelete = false }) => {

    if (!item) {
        return <div>Kein Objekt!</div>;
    }

    if (item.active === false) {
        return (
            <DetailsListItem item={item} onClickDelete={onClickDelete} list={selectedNamedList}>
                <DetailsListItemNameBox>
                    <DetailsListItemTitle>{item.className + '+' + item.classPK}</DetailsListItemTitle>
                </DetailsListItemNameBox>
                <DetailsListItemStatusBox></DetailsListItemStatusBox>
                <DetailsListItemMeasurementBox></DetailsListItemMeasurementBox>
            </DetailsListItem>);
    }

    return (
        <AmdRequireComponent
            key={'FliwasObjectListItem' + item.__type + item.id}
            onDependenciesLoaded={onLoad}
            dependencies={['DetailsListItem/' + item.__type]}
        >
            {
                (DetailsListItem) => (
                    <DetailsListItem
                        item={item}
                        list={selectedNamedList}
                        onClickDelete={onClickDelete}
                        onLoad={onLoad}
                    />
                )
            }
        </AmdRequireComponent>
    );
};

FliwasObjectListItem.propTypes = {
    item: PropTypes.object,
    selectedNamedList: PropTypes.object,
    onClickDelete: PropTypes.bool,
    onLoad: PropTypes.func
};

export default FliwasObjectListItem;



// WEBPACK FOOTER //
// ./js/components/FliwasObjectListItem.jsx